
import { ContractorCard } from "@/components/ContractorCard";
import { Contractor, ViewMode } from "@/types/contractor";
import { useState } from "react";
import { PaginationControls } from "./PaginationControls";

interface ContractorsGridProps {
  contractors: Contractor[];
  viewMode: ViewMode;
}

export const ContractorsGrid = ({ contractors, viewMode }: ContractorsGridProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const contractorsPerPage = 12; // Limit to 12 per page
  
  // Calculate pagination values
  const totalPages = Math.ceil(contractors.length / contractorsPerPage);
  const startIndex = (currentPage - 1) * contractorsPerPage;
  const endIndex = startIndex + contractorsPerPage;
  const currentContractors = contractors.slice(startIndex, endIndex);

  console.log('ContractorsGrid rendering with:', {
    totalContractors: contractors.length,
    currentPage,
    totalPages,
    contractorsShowing: `${startIndex + 1}-${Math.min(endIndex, contractors.length)}`
  });

  return (
    <div>
      <div
        className={`contractors-grid-container ${
          viewMode === "grid"
            ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6"
            : "space-y-4 md:space-y-6"
        }`}
      >
        {currentContractors.map((contractor) => (
          <ContractorCard
            key={contractor.id}
            contractor={contractor}
            viewMode={viewMode}
          />
        ))}
      </div>
      
      {totalPages > 1 && (
        <div className="mt-8">
          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
};
